import * as flags from 'country-flag-icons/string/3x2';
import React from 'react';

import { logger } from '@client/utils/logger.util';

type TCountryFlagProps = {
  country: string;
  className?: string;
};

const Flag = ({ svg }: { svg: string }) => (
  <span dangerouslySetInnerHTML={{ __html: svg }} />
);

export const CountryFlag: React.FC<TCountryFlagProps> = ({
  country,
  className,
}) => {
  let flag: string | null = null;

  if (country && country.length && flags[country]) {
    try {
      flag = flags[country];
    } catch (e) {
      logger.warn('Error encoding flag SVG:', e);
      flag = null;
    }
  } else if (country && country.length) {
    logger.warn('Unknown country:', country);
    flag = null;
  }

  if (!flag) return null;

  return (
    <div className={className}>
      <Flag svg={flag} />
    </div>
  );
};
